import LegalPage from "@/components/LegalPage";
export default function Refund() {
  return <LegalPage contentKey="refundPolicy" />;
}
